import { createContext } from 'react';
export var initialContext = {
  formatMessage: function formatMessage(messageDescriptor, values) {
    return '';
  },
  locale: 'en',
  updateLocale: function updateLocale(locale) {
    return null;
  }
};
export var LocaleContext = createContext(initialContext);